import React from 'react'
import './style.css';
import BackArrow from '../../assets/images/backArrow.svg';
import ProjectOverviewSection from './sections/ProjectOverviewSection';
import AppHeader from '../../components/main/AppHeader';
import { useLocation, useNavigate } from 'react-router-dom';
import ContactSection from '../home/sections/ContactSection';
import AppFooter from '../../components/main/AppFooter';
import FeaturesSection from './sections/FeaturesSection';
import CarouselSection from './sections/CarouselSection';
import mainData from '../../constant/data.json';
export const GetIDFromPath = (location)=>{
    let url = location.pathname
    url = url.split('/');
    if(url && url.length > 1){
          return url[2];
    }else{
      return false;
    }
  }


export default function ProjectDetailsPage(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const onLogoClick =()=>{
        navigate("/")
    }
    const onBackClick =()=>{
        navigate(-1)
    }
    const project = mainData.projects.find(li => li.id === Number(GetIDFromPath(location)))?mainData.projects.find(li => li.id === Number(GetIDFromPath(location))):mainData.projects[0];

    return (
        <div className='project-details-main'> 
          <AppHeader hideMenu onLogoClick={onLogoClick} />
            <img src={require("../../assets/images/projects/" + project.banner)} className='project-details-image' style={{height:project.type === "APP"?'40vw':"50vw"}}  />
            <div onClick={onBackClick}  className='back-arrow-container'>
                <img src={BackArrow} className='back-arrow-img' />
            </div>
            <ProjectOverviewSection project={project} />
            {/* <img src={require("../../assets/images/projects/test.png")} className='project-details-image' /> */}
          {project.images?<CarouselSection  images={project.images} />:null}
          
          
            <FeaturesSection project={project} />
            <ContactSection notHomePage />
            <AppFooter />
        </div>
    )
}


//galaxy
//Maziplay app
//fabien
//pro care
//marsx
//makan
//scan to couopon search freelance



//1 -1:1 for list page
//1 - banner for top
//1 - banner for middle


// {
//     "id":8,
//     "title":"LBI Secondary - Blockchain Trading App",
//     "about":"",
//     "type":"APP",
//     "role":"Developer",
//     "tech":"React Native",
//     "year":"2022",
//     "image":"test.png",
//     "banner":"test.png",
//     "appStore":"",
//     "playStore":"",
//     "webSite":"",
//     "gitHub":"",
//     "features":[

//     ]
// },